import { useEffect } from "react";
import { Box, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AgreementContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    maxWidth: 720,
    margin: "0 auto",
    padding: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(4),
    },
}));

export const AgreementPaper = styled(Paper)(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(3),
    borderRadius: 12,
    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(4),
    },
}));

export const AgreementContent = styled("div")(({ theme }) => ({
    maxWidth: "100%",
    lineHeight: 1.7,
    color: theme.palette.text.secondary,
    "& p": {
        marginBottom: "0.75em",
        overflowWrap: "break-word",
    },
    "& h3": {
        marginTop: "1.25em",
        marginBottom: "0.5em",
    },
    "& strong": {
        color: theme.palette.text.primary,
    },
    "& ul": {
        marginBottom: "0.75em",
        paddingLeft: "1.25em",
    },
    "& li": {
        marginBottom: "0.35em",
    },
}));

export const AgreementScrollToTop = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return null;
};
